/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IdCardConfigDto } from '../models/IdCardConfigDto';
import type { IdCardConfigRequest } from '../models/IdCardConfigRequest';
import type { UpdateIdCardConfigRequest } from '../models/UpdateIdCardConfigRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IdCardConfigurationRestControllerService {
  /**
   * getAll
   * @returns IdCardConfigDto OK
   * @throws ApiError
   */
  public static getAllUsingGet1({
    cardType,
  }: {
    /**
     * card-type
     */
    cardType?: 'STAFF' | 'STUDENT';
  }): CancelablePromise<Array<IdCardConfigDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/id-card-configuration',
      query: {
        'card-type': cardType,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * create
   * @returns IdCardConfigDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createUsingPost4({
    request,
  }: {
    /**
     * request
     */
    request: IdCardConfigRequest;
  }): CancelablePromise<IdCardConfigDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/id-card-configuration',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * update
   * @returns IdCardConfigDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateUsingPut2({
    request,
  }: {
    /**
     * request
     */
    request: UpdateIdCardConfigRequest;
  }): CancelablePromise<IdCardConfigDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/id-card-configuration',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getById
   * @returns IdCardConfigDto OK
   * @throws ApiError
   */
  public static getByIdUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<IdCardConfigDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/id-card-configuration/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * delete
   * @returns any OK
   * @throws ApiError
   */
  public static deleteUsingDelete3({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/id-card-configuration/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
